var exports = {
  "modalBackdrop": "Modal.module__modalBackdrop___Sm85TU",
  "layer": "Modal.module__layer___Sm85TU",
  "backdropSlot": "Modal.module__backdropSlot___Sm85TU",
  "positionAbsoluteInsetZero": "Modal.module__positionAbsoluteInsetZero___Sm85TU",
  "backdropCentered": "Modal.module__backdropCentered___Sm85TU",
  "focusLock": "Modal.module__focusLock___Sm85TU",
  "surface": "Modal.module__surface___Sm85TU",
  "layerFullscreen": "Modal.module__layerFullscreen___Sm85TU",
  "layerFullscreenMobile": "Modal.module__layerFullscreenMobile___Sm85TU",
  "layerCentered": "Modal.module__layerCentered___Sm85TU",
  "root": "Modal.module__root___Sm85TU",
  "centeredOnMobile": "Modal.module__centeredOnMobile___Sm85TU",
  "rootAnimating": "Modal.module__rootAnimating___Sm85TU",
  "medium": "Modal.module__medium___Sm85TU",
  "small": "Modal.module__small___Sm85TU",
  "large": "Modal.module__large___Sm85TU",
  "xlarge": "Modal.module__xlarge___Sm85TU",
  "fullscreen": "Modal.module__fullscreen___Sm85TU",
  "slideInFromRight": "Modal.module__slideInFromRight___Sm85TU",
  "slideOutToRight": "Modal.module__slideOutToRight___Sm85TU",
  "mobileSlideIn": "Modal.module__mobileSlideIn___Sm85TU",
  "mobileSlideOut": "Modal.module__mobileSlideOut___Sm85TU",
  "layout": "Modal.module__layout___Sm85TU",
  "header": "Modal.module__header___Sm85TU",
  "light": "Modal.module__light___Sm85TU",
  "dark": "Modal.module__dark___Sm85TU",
  "footer": "Modal.module__footer___Sm85TU",
  "stretchButtons": "Modal.module__stretchButtons___Sm85TU",
  "headerInner": "Modal.module__headerInner___Sm85TU",
  "headerText": "Modal.module__headerText___Sm85TU",
  "content": "Modal.module__content___Sm85TU",
  "contentNoPadding": "Modal.module__contentNoPadding___Sm85TU",
  "screenReaderLabel": "Modal.module__screenReaderLabel___Sm85TU",
  "insetCloseButtonContainer": "Modal.module__insetCloseButtonContainer___Sm85TU",
  "insetCloseButton": "Modal.module__insetCloseButton___Sm85TU",
  "contentLayout": "Modal.module__contentLayout___Sm85TU",
  "description": "Modal.module__description___Sm85TU",
  "inputGroup": "Modal.module__inputGroup___Sm85TU",
  "formFooter": "Modal.module__formFooter___Sm85TU",
};

__webpack_require__.r(module.exports = exports);
